import { useEffect, useState } from 'react';

export const useScrollbarGutterFallback = () => {
  const [ref, setRef] = useState<HTMLElement>(null);
  const isScrollbarGutterSupported = CSS.supports('scrollbar-gutter', 'stable');
  const [hasScrollVisible, setHasScrollVisible] = useState(false);

  useEffect(() => {
    if (!ref) return;

    const checkIfScrollVisible = () => {
      const updatedHasScrollVisible = ref.scrollHeight > ref.clientHeight;
      setHasScrollVisible(updatedHasScrollVisible);
    };

    const resizeObserver = new ResizeObserver(() => checkIfScrollVisible());
    resizeObserver.observe(ref);

    return () => resizeObserver.disconnect();
  }, [ref]);

  return { shouldApplyFallback: !isScrollbarGutterSupported && !hasScrollVisible, setRef };
};
